import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { mockData } from '../data/mock';
import { BookOpen, Sparkles, Brain, Heart, Star, Menu, X } from 'lucide-react';

const LandingPage = () => {
  const [kirvanoLink] = useState('https://pay.kirvano.com/526f45f3-359a-40fc-a36d-a45c70458971');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileMenuOpen(false);
  };

  return (
    <div className="landing-page">
      {/* Header */}
      <header className="page-header">
        <div className="header-container">
          <div className="header-logo">
            <BookOpen className="logo-icon" />
            <span className="logo-text">Kael'Thurion</span>
          </div>
          <nav className="header-nav">
            <button onClick={() => scrollToSection('sobre')} className="nav-link">Sobre o Livro</button>
            <button onClick={() => scrollToSection('autor')} className="nav-link">Autor</button>
            <button onClick={() => scrollToSection('depoimentos')} className="nav-link">Depoimentos</button>
            <Button onClick={() => scrollToSection('comprar')} className="btn-primary">Comprar Agora</Button>
          </nav>
          <button className="mobile-menu-button" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
            {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
        {mobileMenuOpen && (
          <div className="mobile-menu">
            <button onClick={() => scrollToSection('sobre')} className="mobile-nav-link">Sobre o Livro</button>
            <button onClick={() => scrollToSection('autor')} className="mobile-nav-link">Autor</button>
            <button onClick={() => scrollToSection('depoimentos')} className="mobile-nav-link">Depoimentos</button>
            <Button onClick={() => scrollToSection('comprar')} className="btn-primary" style={{width: '100%'}}>Comprar Agora</Button>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <img 
            src="https://images.unsplash.com/photo-1666112835145-d79fc3f2e008" 
            alt="Quantum Energy" 
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content">
          <h1 className="hero-title">
            ARQUÉTIPOS E A COCRIAÇÃO QUÂNTICA DA REALIDADE
          </h1>
          <p className="hero-subtitle">
            {mockData.heroSubtitle}
          </p>
          
          {/* Bonus Badge */}
          <div className="bonus-badge">
            <div className="bonus-icon">🎁</div>
            <div className="bonus-text">
              <span className="bonus-label">BÔNUS GRÁTIS:</span>
              <span className="bonus-book">Livro "O Homem e Seus Símbolos" de Carl Jung (311 páginas)</span>
            </div>
          </div>
          
          <div className="hero-price">
            <span className="price-label">Por apenas</span>
            <span className="price-value">R$ 10,00</span>
          </div>
          <Button onClick={() => scrollToSection('comprar')} className="btn-primary btn-large">
            Quero Começar a Aprender
          </Button>
        </div>
      </section>

      {/* Bonus Section */}
      <section className="section-bonus">
        <div className="section-container">
          <div className="bonus-card-large">
            <div className="bonus-card-header">
              <h2 className="bonus-card-title">🎁 BÔNUS EXCLUSIVO</h2>
            </div>
            <div className="bonus-card-content">
              <div className="bonus-card-text">
                <h3 className="bonus-book-title">Ganhe GRÁTIS:</h3>
                <p className="bonus-book-name">"O Homem e Seus Símbolos"</p>
                <p className="bonus-book-author">de Carl Jung</p>
                <ul className="bonus-features">
                  <li>✓ Livro completo com 311 páginas</li>
                  <li>✓ Obra clássica sobre arquétipos e inconsciente coletivo</li>
                  <li>✓ Complemento perfeito para aprofundar seus estudos</li>
                  <li>✓ Acesso imediato após a compra</li>
                </ul>
              </div>
              <div className="bonus-card-image">
                <div className="bonus-value-tag">
                  <span className="bonus-value-text">VALOR DO BÔNUS:</span>
                  <span className="bonus-value-price">R$ 40,00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sobre o Livro */}
      <section id="sobre" className="section-about">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Sobre o Livro</h2>
            <div className="title-underline"></div>
          </div>
          <p className="about-description">
            {mockData.aboutBook}
          </p>
          
          <div className="features-grid">
            {mockData.features.map((feature, index) => (
              <Card key={index} className="feature-card">
                <div className="feature-icon">
                  {feature.icon === 'sparkles' && <Sparkles />}
                  {feature.icon === 'brain' && <Brain />}
                  {feature.icon === 'heart' && <Heart />}
                  {feature.icon === 'star' && <Star />}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* O que você vai aprender */}
      <section className="section-learn">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">O Que Você Vai Aprender</h2>
            <div className="title-underline"></div>
          </div>
          <div className="learn-grid">
            <div className="learn-image">
              <img 
                src="https://images.unsplash.com/photo-1506126613408-eca07ce68773" 
                alt="Meditation"
              />
            </div>
            <div className="learn-content">
              <ul className="learn-list">
                {mockData.learningPoints.map((point, index) => (
                  <li key={index} className="learn-item">
                    <span className="learn-bullet"></span>
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Sobre o Autor */}
      <section id="autor" className="section-author">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Sobre o Autor</h2>
            <div className="title-underline"></div>
          </div>
          <div className="author-content">
            <div className="author-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_ef0b59e6-70c2-4cb3-a24c-b7db2bcff313/artifacts/b6o8d6lx_kt.png" 
                alt="Kael'Thurion"
              />
            </div>
            <div className="author-info">
              <h3 className="author-name">Kael'Thurion</h3>
              <p className="author-bio">
                {mockData.authorBio}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section id="depoimentos" className="section-testimonials">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">O Que Dizem os Leitores</h2>
            <div className="title-underline"></div>
          </div>
          <div className="testimonials-grid">
            {mockData.testimonials.map((testimonial, index) => (
              <Card key={index} className="testimonial-card">
                <div className="testimonial-rating">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="star-icon" fill="#d9fb06" />
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <span className="testimonial-name">{testimonial.name}</span>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section id="comprar" className="section-cta">
        <div className="cta-content">
          <h2 className="cta-title">
            COMECE SUA JORNADA DE DESCOBERTA
          </h2>
          <p className="cta-description">
            Adquira agora a introdução "Arquétipos e a Cocriação Quântica da Realidade"
          </p>
          
          <div className="cta-bonus-highlight">
            <span className="cta-bonus-icon">🎁</span>
            <span className="cta-bonus-text">+ GRÁTIS: "O Homem e Seus Símbolos" de Carl Jung (311 páginas)</span>
          </div>
          
          <div className="cta-price-container">
            <div className="cta-original-price">
              <span className="price-crossed">De R$ 50,00</span>
            </div>
            <div className="cta-price">
              <span className="cta-price-label">Por apenas</span>
              <span className="cta-price-value">R$ 10,00</span>
            </div>
          </div>
          
          <a href={kirvanoLink} target="_blank" rel="noopener noreferrer">
            <Button className="btn-primary btn-large">
              Comprar na Kirvano
            </Button>
          </a>
          <p className="cta-guarantee">
            ✓ Acesso imediato aos 2 livros após a compra
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="page-footer">
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-logo">
              <BookOpen className="logo-icon" />
              <span className="logo-text">Kael'Thurion</span>
            </div>
            <p className="footer-text">
              © 2025 Kael'Thurion. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;